<template>
    <div class="register-box">
        <div class="card">
            <div class="card-body register-card-body">
                <p class="login-box-msg"><h3 class="text-center">Aktivasi User</h3></p>
                <div class="text-center" :class="alertStatus" v-if="showMessage">{{ textMessage }}</div>
                <br>
                <div class="text-center">
                    <a v-if="redirectUrl" :href="redirectUrl" class="text-center">Kembali ke halaman login</a>
                    <router-link v-else to="/login" class="text-center">Kembali ke halaman login</router-link>
                </div>
            </div>
            <!-- /.form-box -->
        </div><!-- /.card -->
    </div>
</template>
<script>
// import { createTable, authFetch } from '@/libs/hxcore';

import $ from 'jquery';
export default {
    name: 'UserActivate',
    data() {
        return {
            errors: [],
            method: '',
            roles: '',
            disabled: false,
            groups: [],
            showMessage: true,
            textMessage: 'Periksa...',
            alertStatus: '',
            form: {
                id: '',
                key: '',
                pass: '',
                pass2: ''
            },
            redirectUrl: null,
        }
    },
    computed: {},
    created: function() {
        $('body').addClass('register-page');
        $('body').removeAttr('style');
        this.form.id = this.$route.params.id;
        if(this.form.id)
            this.checkData(this.form.id);
    },
    mounted() {

    },
    beforeDestroy() {
        $('body').removeClass('register-page');
    },
    methods: {
        checkData: function(id) {
            // capture redirect param from route query
            this.redirectUrl = (this.$route && this.$route.query && this.$route.query.redirect) ? this.$route.query.redirect : null;

            fetch(window.$apiUrl + '/users/register/activate?code=' + id)
            .then(res => {
                if (res.status === 201) {
                } else if (res.status === 400) {
                }
                return res.json();
            })
            .then(js => {
                if (js.status) {
                    this.textMessage = js.message;
                    this.alertStatus = 'alert alert-success';
                    
                    // Track Facebook Pixel CompleteRegistration event
                    // this.trackCompleteRegistration();
                    
                    // if a redirect query param was provided, navigate after success
                    if (this.redirectUrl) {
                        // wait 3 seconds so the user can see the success message
                        setTimeout(() => {
                            try {
                                const url = new URL(this.redirectUrl, window.location.origin);
                                // if same-origin, use vue-router to preserve SPA behavior
                                if (url.origin === window.location.origin) {
                                    this.$router.push(url.pathname + url.search + url.hash).catch(() => {});
                                } else {
                                    // external URL, perform full redirect
                                    window.location.href = this.redirectUrl;
                                }
                            } catch (e) {
                                // invalid URL? fallback to simple router push
                                this.$router.push(this.redirectUrl).catch(() => {});
                            }
                        }, 3000);
                    }
                }
                else{                    
                    this.textMessage = js.message;
                    this.showMessage = true;
                    this.alertStatus = 'alert alert-danger';
                    this.disabled = true;
                }
              
            });
        },
        trackCompleteRegistration: function() {
            // Check if fbq is available
            if (typeof window.fbq === 'undefined') {
                console.warn('Facebook Pixel (fbq) is not available');
                return;
            }

            try {
                // Check if redirectUrl matches bosOnline target URL
                const bosOnlineUrl = 'https://app.bosonline.id/';
                const decodedRedirectUrl = this.redirectUrl ? decodeURIComponent(this.redirectUrl) : '';
                
                const eventData = {
                    content_name: 'User Activation',
                    status: 'completed',
                    value: 0,
                    currency: 'IDR'
                };

                if (decodedRedirectUrl === bosOnlineUrl) {
                    // Track for bosOnline pixel only
                    window.fbq('trackSingle', '1724137074958115', 'CompleteRegistration', {
                        ...eventData,
                        source: 'bosOnline'
                    });
                    console.log('Facebook Pixel: CompleteRegistration tracked for bosOnline (1724137074958115)');
                } else {
                    // Track for default pixels (bosCOD)
                    window.fbq('track', 'CompleteRegistration', {
                        ...eventData,
                        source: 'default'
                    });
                    console.log('Facebook Pixel: CompleteRegistration tracked for default pixels (bosCOD)');
                }
            } catch (error) {
                console.error('Error tracking Facebook Pixel event:', error);
            }
        },
        resetForm: function() {
            for (const key in this.$refs) {
                this.$refs[key].setAttribute('title', '');
                this.$refs[key].classList.remove('is-invalid');
            }
        }
    }
}
</script>